import React from 'react';
import { IconProps } from '.';

const SvgBox = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M14.5 13.25h-5v1.5h5v-1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.25 2.75h19.5v5.5h-1v13H3.25v-13h-1v-5.5Zm2.5 5.5h14.5v11.5H4.75V8.25Zm15.5-4v2.5H3.75v-2.5h16.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBox;
